<template>
  <div>
    <NavigationBar/>

    <!-- Search for bill -->
    <div class="modal fade" id="searchBillModal" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="staticBackdropLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header border-bottom-0">
            <button type="button" class="btn-close d-none" data-dismiss="modal" aria-label="Close"></button>
          </div>

          <footer class="footer">
            <div class="container-fluid">
              <div class="row">
                <div class="col-sm-6">
                </div>
                <div class="col-sm-6">
                  <div class="text-sm-end d-sm-block">
                    2024
                  </div>
                </div>
              </div>
            </div>
          </footer>
          <div class="modal-body">
            <div class="text-center mb-4">
              <div class="avatar-md mx-auto mb-4">
                <div class="avatar-title bg-light rounded-circle text-success h1">
                  <i class="bx bx-receipt"></i>
                </div>
              </div>

              <div class="row justify-content-center">
                <div class="col-xl-10">
                  <h4 class="text-primary">Enter Bill Number To continue</h4>
                  <p class="text-muted font-size-14 mb-4">
                    Enter bill No to continue.
                  </p>

                  <form>
                    <div class="row">
                      <div class="col-12">
                        <div class="mb-3">
                          <label for="digit1-input" class="visually-hidden">Bill No.</label>
                          <input v-model="billNo" type="text" class="form-control form-control-lg text-center two-step" placeholder="Search for Bill">
                        </div>
                      </div>
                    </div>
                    <button data-dismiss="modal" @click="getBill()" type="button" class="btn btn-success btn-block w-100">
                      <i class="bx bx-search-alt-2 font-size-16 align-middle me-2"></i>
                      Search
                    </button>
                  </form>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Search for bill -->

    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->
    <div id="content" class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">

          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Project Consultants</h4>

                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="index.html">Home</a></li>
                    <li class="breadcrumb-item active">Projects</li>
                  </ol>
                </div>

              </div>
            </div>
          </div>
          <!-- end page title -->

          <!-- Alert message -->
          <div v-if="alert.success || alert.info || alert.failed" class="row">
            <div class="col-12">
              <div :class="{'alert alert-success': alert.success, 'alert alert-info': alert.info, 'alert alert-danger': alert.failed}" role="alert">
                {{ message }}
              </div>
            </div>
          </div>

          <!-- stats cards -->
          <div class="row">
            <!-- Total Projects -->
            <div class="col-lg-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Total Projects</p>
                      <h5 class="mb-0">{{ projectStats.total }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-primary rounded-circle text-white font-size-20">
                        <i class="mdi mdi-clipboard-text"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Delayed Projects -->
            <div class="col-lg-3 col-md-6">
              <div class="card blog-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Delayed Projects</p>
                      <h5 class="mb-0">{{ projectStats.delayed }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-danger rounded-circle text-white font-size-20">
                        <i class="mdi mdi-timer-sand"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Unassigned Projects -->
            <div class="col-lg-3 col-md-6">
              <div class="card blog-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Unassigned Projects</p>
                      <h5 class="mb-0">{{ projectStats.unassigned }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-warning rounded-circle text-white font-size-20">
                        <i class="mdi mdi-account-question"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Projects Nearing Deadline -->
            <div class="col-lg-3 col-md-6">
              <div class="card blog-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Nearing Deadline</p>
                      <h5 class="mb-0">{{ projectStats.nearingDeadline }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-dark rounded-circle text-white font-size-20">
                        <i class="mdi mdi-calendar-alert"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- end of stats -->
          <div class="row">
            <div class="col-12">
              <div class="card">

                <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">

                  <div class="btn-toolbar p-3 d-flex justify-content-between align-items-center w-100" role="toolbar">
                    <div class="flex-grow-1">
                      <div class="search-box mb-0 me-3">
                        <div class="position-relative">
                          <input v-model="searchQuery" type="text" class="form-control bg-light border-light rounded" placeholder="Search..." fdprocessedid="husj3l" spellcheck="false">
                          <i class="bx bx-search-alt search-icon"></i>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex">
                      <div class="d-flex align-items-center me-3 pe-3">
                        <div>
                          <div class="float-end d-flex">
                            <div class="input-group fw-semibold text-uppercase me-3">
                              <label class="input-group-text text-uppercase">Department</label>
                              <select v-model="selectedDepartment" @change="filterProjects" class="form-select" style="width: 200px;">
                                <option selected="selected" value="">All Departments</option>
                                <option v-for="dept in departments" :key="dept.id" :value="dept.id">{{ dept.name }}</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <button data-bs-toggle="modal" data-bs-target=".download-modal" type="button" class="btn btn-primary dropdown-toggle option-selector me-3 text-capitalize">
                        <i class="bx bxs-download"></i> <span class="pl-1 d-md-inline">Download Report</span>
                      </button>

                      <!-- Add Project Button -->
                      <button data-bs-toggle="modal" data-bs-target="#modal-add-asset" type="button" class="btn btn-success dropdown-toggle option-selector me-3 text-capitalize">
                        <i class="bx bx-plus"></i> <span class="pl-1 d-md-inline">Add Project</span>
                      </button>
                    </div>
                  </div>
                  <div class="btn-toolbar p-3 align-items-center d-none animated delete-tool-bar" role="toolbar">
                    <button type="button" data-bs-toggle="modal" data-bs-target=".download-modal" class="btn btn-primary waves-effect btn-label waves-light me-3"><i class="mdi mdi-printer label-icon"></i> Print Selected Invoices</button>
                  </div>
                </div>

                <div class="card-body">
                  <div class="table-responsive">
                    <!-- Projects Table -->
                    <table class="table align-middle table-hover projects-table table-striped text-nowrap" id="datatable-buttons">
                      <thead class="table-light">
                      <tr class="table-dark">
                        <th scope="col">Project Name</th>
                        <th scope="col">Client</th>
                        <th scope="col">Date Added</th>
                        <th scope="col">Completion Date</th>
                        <th scope="col">Assigned Personnel</th>
                        <th scope="col">No. of Staff</th>
                        <th scope="col">Status</th>
                        <th scope="col">Termination Date</th>
                        <th scope="col">Total Budget</th>
                        <th scope="col">Actual Cost</th>
                        <th scope="col">Department</th>
                        <th scope="col">Action</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="project in projects" :key="project.id">
                        <td>{{ project.projectName }}</td>
                        <td>{{ project.clientName || 'N/A' }}</td>
                        <td>{{ formatDate(project.createdAt) }}</td>
                        <td>{{ formatDate(project.endDate) }}</td>
                        <td>{{ project.assignedPersonnel }}</td>
                        <td>{{ project.staffCount }}</td>
                        <td>
                          <span :class="getStatusBadgeClass(project.status)">{{ project.status }}</span>
                        </td>
                        <td>{{ formatDate(project.endDate) }}</td>
                        <td>{{project.currency}} {{ formatNumber(project.budget) }}</td>
                        <td>{{project.currency}} {{ formatNumber(project.actualCost) }}</td>
                        <td>{{ project.departmentName }}</td>
                        <td>
                          <button style="margin-right: 5px" class="btn btn-primary btn-sm" data-bs-toggle="modal" data-bs-target="#editProjectModal" @click="selectProject(project)">Edit</button>

                          <!-- Activate button (only for Pending projects) -->
                          <button style="margin-right: 5px"  v-if="project.status === 'pending'"
                                  class="btn btn-success btn-sm"
                                  @click="activateProject(project.id)">
                            Activate
                          </button>

                          <!-- Close button (not for Closed projects) -->
                          <button style="margin-right: 5px" v-if="project.status !== 'closed'"
                                  class="btn btn-danger btn-sm"
                                  @click="closeProject(project.id)">
                            Close Project
                          </button>

                          <button @click="openProjectMembersModal(project)" class="btn btn-info btn-sm">
                            Add Members
                          </button>
                        </td>
                      </tr>
                      </tbody>
                    </table>

                    <!-- Loading indicator -->
                    <div v-if="loading" class="text-center my-3">
                      <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                      <p class="mt-2">Loading projects...</p>
                    </div>

                    <!-- No projects message -->
                    <div v-if="!loading && projects.length === 0" class="text-center my-5">
                      <i class="bx bx-folder-open text-muted display-4"></i>
                      <p class="mt-2">No projects found</p>
                    </div>


                    <!-- Edit Project Modal -->
                    <div class="modal fade" id="editProjectModal" tabindex="-1" aria-labelledby="editProjectModalLabel" aria-hidden="true">
                      <div class="modal-dialog modal-dialog-centered modal-lg">
                        <div class="modal-content">
                          <div class="modal-header bg-white text-dark">
                            <h5 class="modal-title" id="editProjectModalLabel">
                              <i class="bx bx-edit me-2"></i>Edit Project
                            </h5>
                            <button type="button" class="btn-close btn-close-dark" data-bs-dismiss="modal" aria-label="Close"></button>
                          </div>
                          <div class="modal-body">
                            <form @submit.prevent="updateProject">
                              <!-- Form layout in two columns for better space utilization -->
                              <div class="row">
                                <!-- Left Column -->
                                <div class="col-md-6">
                                  <!-- Project Name with validation -->
                                  <div class="mb-3">
                                    <label for="projectName" class="form-label fw-bold">Project Name <span class="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="projectName"
                                        v-model="currentProject.projectName"
                                        placeholder="Enter project name"
                                        required
                                        autofocus
                                    >
                                  </div>

                                  <!-- Client Name -->
                                  <div class="mb-3">
                                    <label for="clientName" class="form-label fw-bold">Client Name <span class="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="clientName"
                                        v-model="currentProject.clientName"
                                        placeholder="Enter client name"
                                        required
                                    >
                                  </div>

                                  <!-- Department Dropdown with better styling -->
                                  <div class="mb-3">
                                    <label for="department" class="form-label fw-bold">Department <span class="text-danger">*</span></label>
                                    <select
                                        class="form-select"
                                        id="department"
                                        v-model="currentProject.departmentID"
                                        required
                                    >
                                      <option value="" disabled>Select Department</option>
                                      <option v-for="dept in departments" :key="dept.id" :value="dept.id">{{ dept.departmentName }}</option>
                                    </select>
                                  </div>

                                  <!-- Person in Charge Dropdown with search functionality -->
                                  <div class="mb-3">
                                    <label for="inCharge" class="form-label fw-bold">Person in Charge {{currentProject.managerID}} <span class="text-danger">*</span></label>
                                    <div class="input-group mb-2">
                                      <input
                                          type="text"
                                          class="form-control"
                                          v-model="personnelSearchKeyword"
                                          placeholder="Search for personnel"
                                          @input="searchEmployees"
                                      >
                                      <button class="btn btn-outline-primary" type="button" @click="searchEmployees">
                                        <i class="bx bx-search"></i>
                                      </button>
                                    </div>
                                    <select
                                        class="form-select"
                                        id="inCharge"
                                        v-model="currentProject.managerID"
                                        required
                                    >
                                      <option value="" disabled>Select Person</option>
                                      <option v-for="employee in employees" :key="employee.id" :value="employee.id">
                                        {{ employee.firstName }} - {{ employee.designation || 'No designation' }}
                                      </option>
                                    </select>
                                  </div>
                                </div>

                                <!-- Right Column -->
                                <div class="col-md-6">
                                  <!-- Project Dates Group -->
                                  <div class="card mb-3 border-light bg-light">
                                    <div class="card-body">
                                      <h6 class="card-title mb-3">Project Timeline</h6>
                                      <!-- Start Date -->
                                      <div class="mb-3">
                                        <label for="startDate" class="form-label fw-bold">Start Date <span class="text-danger">*</span></label>
                                        <input
                                            type="date"
                                            class="form-control"
                                            id="startDate"
                                            v-model="currentProject.createdAt"
                                            required
                                        >
                                      </div>
                                      <!-- End Date -->
                                      <div class="mb-3">
                                        <label for="endDate" class="form-label fw-bold">End Date <span class="text-danger">*</span></label>
                                        <input
                                            type="date"
                                            class="form-control"
                                            id="endDate"
                                            v-model="currentProject.endDate"
                                            required
                                        >
                                      </div>
                                    </div>
                                  </div>

                                  <!-- Financial Details Group -->
                                  <div class="card mb-3 border-light bg-light">
                                    <div class="card-body">
                                      <h6 class="card-title mb-3">Financial Details</h6>
                                      <!-- Project Budget with currency symbol -->
                                      <div class="mb-3">
                                        <label for="projectBudget" class="form-label fw-bold">Budget (KES)</label>
                                        <div class="input-group">
                                          <span class="input-group-text">KES</span>
                                          <input
                                              type="number"
                                              class="form-control"
                                              id="projectBudget"
                                              v-model="currentProject.budget"
                                              placeholder="Enter budget amount"
                                              min="0"
                                          >
                                        </div>
                                      </div>

                                      <!-- Actual Cost with currency symbol -->
                                      <div class="mb-3">
                                        <label for="projectActualCost" class="form-label fw-bold">Actual Cost (KES)</label>
                                        <div class="input-group">
                                          <span class="input-group-text">KES</span>
                                          <input
                                              type="number"
                                              class="form-control"
                                              id="projectActualCost"
                                              v-model="currentProject.actualCost"
                                              placeholder="Enter actual cost amount"
                                              min="0"
                                          >
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <!-- Project Location -->
                                  <div class="mb-3">
                                    <label for="projectLocation" class="form-label fw-bold">Project Location</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="projectLocation"
                                        v-model="currentProject.location"
                                        placeholder="Enter location"
                                    >
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                          <div class="modal-footer">
                            <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">
                              <i class="bx bx-x me-1"></i>Cancel
                            </button>
                            <button
                                type="button"
                                class="btn btn-primary"
                                @click="updateProject"
                                :disabled="!currentProject.assignedPersonnel || !currentProject.clientName || !currentProject.departmentID || !currentProject.managerID || !currentProject.createdAt || !currentProject.endDate"
                            >
                              <i class="bx bx-save me-1"></i>Save Changes
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- end col -->
          </div>

          <!-- end row -->
        </div>
        <!-- container-fluid -->
      </div>
      <!-- End Page-content -->

      <!-- Add Project Modal -->
      <!-- Add Project Modal -->
      <div class="modal fade" id="modal-add-asset" tabindex="-1" aria-labelledby="addAssetModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-primary text-white">
              <h5 class="modal-title" id="addAssetModalLabel">
                <i class="bx bx-plus-circle me-2"></i>Add New Project
              </h5>
              <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="addProject">
                <!-- Form layout in two columns for better space utilization -->
                <div class="row">
                  <!-- Left Column -->
                  <div class="col-md-6">
                    <!-- Project Name with validation -->
                    <div class="mb-3">
                      <label for="newProjectName" class="form-label fw-bold">Project Name <span class="text-danger">*</span></label>
                      <input
                          type="text"
                          class="form-control"
                          id="newProjectName"
                          v-model="newProject.projectName"
                          placeholder="Enter project name"
                          required
                          autofocus
                      >
                      <div class="form-text">Provide a clear, descriptive name for the project</div>
                    </div>

                    <!-- Client Name -->
                    <div class="mb-3">
                      <label for="newClientName" class="form-label fw-bold">Client Name <span class="text-danger">*</span></label>
                      <input
                          type="text"
                          class="form-control"
                          id="newClientName"
                          v-model="newProject.clientName"
                          placeholder="Enter client name"
                          required
                      >
                    </div>

                    <!-- Department Dropdown with better styling -->
                    <div class="mb-3">
                      <label for="newDepartment" class="form-label fw-bold">Department <span class="text-danger">*</span></label>
                      <select
                          class="form-select"
                          id="newDepartment"
                          v-model="newProject.departmentID"
                          required
                      >
                        <option value="" disabled>Select Department</option>
                        <option v-for="dept in departments" :key="dept.id" :value="dept.id">{{ dept.departmentName }}</option>
                      </select>
                    </div>

                    <!-- Person in Charge Dropdown with search functionality -->
                    <div class="mb-3">
                      <label for="newInCharge" class="form-label fw-bold">Person in Charge <span class="text-danger">*</span></label>
                      <div class="input-group mb-2">
                        <input
                            type="text"
                            class="form-control"
                            v-model="personnelSearchKeyword"
                            placeholder="Search for personnel"
                            @input="searchEmployees"
                        >
                        <button class="btn btn-outline-primary" type="button" @click="searchEmployees">
                          <i class="bx bx-search"></i>
                        </button>
                      </div>
                      <select
                          class="form-select"
                          id="newInCharge"
                          v-model="newProject.managerID"
                          required
                      >
                        <option value="" disabled>Select Person</option>
                        <option v-for="employee in employees" :key="employee.id" :value="employee.id">
                          {{ employee.firstName }} - {{ employee.designation || 'No designation' }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <!-- Right Column -->
                  <div class="col-md-6">
                    <!-- Project Dates Group -->
                    <div class="card mb-3 border-light bg-light">
                      <div class="card-body">
                        <h6 class="card-title mb-3">Project Timeline</h6>
                        <!-- Start Date -->
                        <div class="mb-3">
                          <label for="newStartDate" class="form-label fw-bold">Start Date <span class="text-danger">*</span></label>
                          <input
                              type="date"
                              class="form-control"
                              id="newStartDate"
                              v-model="newProject.createdAt"
                              required
                          >
                        </div>
                        <!-- End Date -->
                        <div class="mb-3">
                          <label for="newEndDate" class="form-label fw-bold">End Date <span class="text-danger">*</span></label>
                          <input
                              type="date"
                              class="form-control"
                              id="newEndDate"
                              v-model="newProject.endDate"
                              required
                          >
                        </div>
                      </div>
                    </div>

                    <!-- Financial Details Group -->
                    <div class="card mb-3 border-light bg-light">
                      <div class="card-body">
                        <h6 class="card-title mb-3">Financial Details</h6>
                        <!-- Project Budget with currency symbol -->
                        <div class="mb-3">
                          <label for="newProjectBudget" class="form-label fw-bold">Budget (KES)</label>
                          <div class="input-group">
                            <span class="input-group-text">KES</span>
                            <input
                                type="number"
                                class="form-control"
                                id="newProjectBudget"
                                v-model="newProject.budget"
                                placeholder="Enter budget amount"
                                min="0"
                            >
                          </div>
                        </div>

                        <!-- Actual Cost with currency symbol -->
                        <div class="mb-3">
                          <label for="newProjectActualCost" class="form-label fw-bold">Actual Cost (KES)</label>
                          <div class="input-group">
                            <span class="input-group-text">KES</span>
                            <input
                                type="number"
                                class="form-control"
                                id="newProjectActualCost"
                                v-model="newProject.actualCost"
                                placeholder="Enter actual cost amount"
                                min="0"
                            >
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Project Location -->
                    <div class="mb-3">
                      <label for="newProjectLocation" class="form-label fw-bold">Project Location</label>
                      <input
                          type="text"
                          class="form-control"
                          id="newProjectLocation"
                          v-model="newProject.location"
                          placeholder="Enter location"
                      >
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">
                <i class="bx bx-x me-1"></i>Cancel
              </button>
              <button
                  type="button"
                  class="btn btn-primary"
                  @click="addProject"
                  :disabled="!newProject.projectName || !newProject.clientName || !newProject.departmentID || !newProject.managerID || !newProject.createdAt || !newProject.endDate"
              >
                <i class="bx bx-save me-1"></i>Add Project
              </button>
              <!-- For debugging - uncomment during development if needed
              <button
                  type="button"
                  class="btn btn-secondary"
                  @click="checkFormValidity"
              >
                <i class="bx bx-bug me-1"></i>Check Validity
              </button>
              -->
            </div>
          </div>
        </div>
      </div>
      <!-- Add Project Members Modal (continued) -->
      <div class="modal fade" id="addProjectMembersModal" tabindex="-1" aria-labelledby="addProjectMembersModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="addProjectMembersModalLabel">
                Project Members - {{ selectedProject ? selectedProject.name : '' }}
              </h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="row mb-4">
                <div class="col-12">
                  <div class="card">
                    <div class="card-header bg-light">
                      <h6 class="mb-0">Add New Member</h6>
                    </div>
                    <div class="card-body">
                      <form @submit.prevent="addProjectMember">
                        <div class="row">
                          <div class="col-md-6 mb-3">
                            <label for="member" class="form-label">Select Member</label>
                            <div class="input-group">
                              <input
                                  type="text"
                                  class="form-control"
                                  v-model="personnelSearchKeyword"
                                  placeholder="Search for personnel"
                                  @input="searchEmployees"
                              >
                              <button class="btn btn-outline-secondary" type="button" @click="searchEmployees">
                                <i class="bx bx-search"></i>
                              </button>
                            </div>
                            <select class="form-select mt-2" id="member" v-model="newProjectMember.employeeID">
                              <option value="">Select Member</option>
                              <option v-for="employee in employees" :key="employee.id" :value="employee.id">{{ employee.firstName }}</option>
                            </select>
                          </div>

                          <div class="col-md-6 mb-3">
                            <label for="role" class="form-label">Role in Project</label>
                            <input type="text" class="form-control" id="role" v-model="newProjectMember.role" placeholder="Enter role (e.g. Developer, Designer)">
                          </div>
                        </div>

                        <div class="text-end">
                          <button type="submit" class="btn btn-primary">Add Member</button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="card">
                    <div class="card-header bg-light">
                      <h6 class="mb-0">Current Project Members</h6>
                    </div>
                    <div class="card-body">
                      <div class="table-responsive">
                        <table class="table align-middle">
                          <thead>
                          <tr>
                            <th>Name</th>
                            <th>Role</th>
                            <th>Department</th>
                            <th>Actions</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="member in projectMembers" :key="member.memberID">
                            <td>{{ member.employeeName }}</td>
                            <td>{{ member.role }}</td>
                            <td>{{ member.departmentName }}</td>
                            <td>
                              <button class="btn btn-danger btn-sm" @click="removeProjectMember(member.memberID)">
                                <i class="bx bx-trash"></i>
                              </button>
                            </td>
                          </tr>
                          <tr v-if="projectMembers.length === 0">
                            <td colspan="4" class="text-center py-3">No members added to this project yet</td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation.vue";
import { authUrl, execute, getRight } from "@/api";

export default {
  name: "ProjectsConsultants",
  computed: {
    declined() {
      return declined;
    },
  },
  components: { NavigationBar },
  data() {
    return {
      message: '',
      alert: {
        success: false,
        info: false,
        failed: false
      },
      loading: true,
      searchQuery: '',
      selectedDepartment: '',
      projects: [],
      departments: [],
      employees: [],
      personnelSearchKeyword: '',
      searchTimeout: null,
      selectedProject: null,
      projectMembers: [],
      newProjectMember: {
        projectID: "",
        employeeID: "",
        role: "",
        joinDate: "",
        endDate: null,
        timeAllocation: 100,
      },
      projectStats: {
        total: 0,
        delayed: 0,
        unassigned: 0,
        nearingDeadline: 0
      },
      currentProject: {
        id: null,
        projectName: "",
        description: "",
        startDate: null,
        endDate: null,
        status: "pending",
        priority: "medium",
        budget: 0,
        actualCost: 0,
        managerID: "",
        assignedPersonnel: "",
        departmentID: "",
        departmentName: "",
        clientName: "",
        createdAt: "",
        updatedAt: null,
        staffCount: 0,
        currency: "KES",
        location: "",
        isDelayed: false,
        isUnassigned: false,
        isNearingDeadline: false
      },
      newProject: {
        projectName: "",
        description: "",
        status: "pending",
        priority: "medium",
        budget: 0,
        actualCost: 0,
        managerID: "",
        departmentID: "",
        clientName: "",
        createdAt: "",
        endDate: "",
        location: "",
        currency: "KES"
      }
    };
  },
  mounted() {
    this.getProjects();
    this.getDepartments();
    this.getEmployees();

    // Initialize current date for the start date field
    const today = new Date().toISOString().split('T')[0];
    this.newProject.createdAt = today;
  },
  methods: {
    authUrl() {
      return authUrl;
    },
    getRight(type) {
      return getRight(type);
    },

    // Debugging method to check form validity
    checkFormValidity() {
      console.log("Form validity check:");
      console.log("Project Name:", this.newProject.projectName, Boolean(this.newProject.projectName));
      console.log("Client Name:", this.newProject.clientName, Boolean(this.newProject.clientName));
      console.log("Department ID:", this.newProject.departmentID, Boolean(this.newProject.departmentID));
      console.log("Manager ID:", this.newProject.managerID, Boolean(this.newProject.managerID));
      console.log("Created At:", this.newProject.createdAt, Boolean(this.newProject.createdAt));
      console.log("End Date:", this.newProject.endDate, Boolean(this.newProject.endDate));

      const isValid = Boolean(
          this.newProject.projectName &&
          this.newProject.clientName &&
          this.newProject.departmentID &&
          this.newProject.managerID &&
          this.newProject.createdAt &&
          this.newProject.endDate
      );

      console.log("Form is valid:", isValid);
      return isValid;
    },

    // Get all projects
    getProjects() {
      this.loading = true;
      const data = new FormData();
      data.append("function", "getProjects");

      execute(data, authUrl)
          .then((res) => {
            this.loading = false;
            if (res.data.success) {
              this.projects = res.data.data.projects;
              this.projectStats = res.data.data.projectStats;
            } else {
              this.message = res.data.message || "Failed to load projects";
              this.showAlert('failed');
            }
          })
          .catch((e) => {
            this.loading = false;
            this.message = e.message || "An error occurred while loading projects";
            this.showAlert('failed');
          });
    },

    // Get departments for filtering
    getDepartments() {
      const data = new FormData();
      data.append("function", "getDepartments");

      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              this.departments = res.data.data.departments;
            } else {
              console.error("Failed to load departments:", res.data.message);
            }
          })
          .catch((e) => {
            console.error("Error loading departments:", e);
          });
    },

    // Get personnel for project assignment
    getEmployees(keyword = '') {
      const data = new FormData();
      data.append("function", "getEmployees");
      data.append("keyword", keyword);

      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              this.employees = res.data.data.employees;
            } else {
              console.error("Failed to load employees:", res.data.message);
            }
          })
          .catch((e) => {
            console.error("Error loading employees:", e);
          });
    },

    /**
     * Properly closes all Bootstrap modals and removes their backdrops
     * This function ensures that both the modal and backdrop elements are completely removed
     */
    closeAllModals() {
      // First close all modals using Bootstrap's API
      const modals = document.querySelectorAll('.modal.show');
      modals.forEach(modal => {
        const modalInstance = bootstrap.Modal.getInstance(modal);
        if (modalInstance) {
          modalInstance.hide();
        }
      });

      // Then remove any lingering backdrop elements
      const backdrops = document.querySelectorAll('.modal-backdrop');
      backdrops.forEach(backdrop => {
        backdrop.remove();
      });

      // Finally, fix the body by removing modal-open class and inline styles
      document.body.classList.remove('modal-open');
      document.body.style.removeProperty('padding-right');
      document.body.style.removeProperty('overflow');
    },

    // Add new project
    addProject() {
      // Validate the form first
      if (!this.checkFormValidity()) {
        this.message = "Please fill in all required fields";
        this.showAlert('failed');
        return;
      }

      this.showAlert('info');
      const data = new FormData();
      data.append("function", "addProject");
      data.append("projectName", this.newProject.projectName);
      data.append("departmentID", this.newProject.departmentID);
      data.append("managerID", this.newProject.managerID);
      data.append("startDate", this.newProject.createdAt); // Make sure this is correct
      data.append("endDate", this.newProject.endDate);
      data.append("budget", this.newProject.budget || 0);
      data.append("actualCost", this.newProject.actualCost || 0);
      data.append("description", this.newProject.description || '');
      data.append("clientName", this.newProject.clientName);
      data.append("location", this.newProject.location || '');

      // Log the data being sent to the API for debugging
      console.log("Sending data to API:", {
        projectName: this.newProject.projectName,
        departmentID: this.newProject.departmentID,
        managerID: this.newProject.managerID,
        startDate: this.newProject.createdAt,
        endDate: this.newProject.endDate,
        budget: this.newProject.budget || 0,
        actualCost: this.newProject.actualCost || 0,
        description: this.newProject.description || '',
        clientName: this.newProject.clientName,
        location: this.newProject.location || ''
      });

      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              this.message = "Project added successfully";
              this.showAlert('success');
              this.getProjects(); // Refresh projects list

              // Close modal
              this.closeAllModals();

              // Reset form
              this.resetNewProjectForm();
            } else {
              this.message = res.data.message || "Failed to add project";
              this.showAlert('failed');
              console.error("API Error:", res.data);
            }
          })
          .catch((e) => {
            this.message = e.message || "An error occurred";
            this.showAlert('failed');
            console.error("Exception:", e);
          });
    },

    // Update existing project
    updateProject() {
      this.showAlert('info');
      const data = new FormData();
      data.append("function", "updateProject");
      data.append("projectID", this.currentProject.id);
      data.append("projectName", this.currentProject.projectName);
      data.append("departmentID", this.currentProject.departmentID);
      data.append("managerID", this.currentProject.managerID);
      data.append("startDate", this.currentProject.createdAt);
      data.append("endDate", this.currentProject.endDate);
      data.append("budget", this.currentProject.budget || 0);
      data.append("actualCost", this.currentProject.actualCost || 0);
      data.append("description", this.currentProject.description || '');
      data.append("clientName", this.currentProject.clientName);
      data.append("location", this.currentProject.location || '');

      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              this.message = "Project updated successfully";
              this.showAlert('success');
              this.getProjects(); // Refresh projects list
              this.closeAllModals();
            } else {
              this.message = res.data.message || "Failed to update project";
              this.showAlert('failed');
            }
          })
          .catch((e) => {
            this.message = e.message || "An error occurred while updating the project";
            this.showAlert('failed');
          });
    },

    // Close a project
    closeProject(projectId) {
      if (confirm("Are you sure you want to close this project?")) {
        this.showAlert('info');
        const data = new FormData();
        data.append("function", "closeProject");
        data.append("projectID", projectId);

        execute(data, authUrl)
            .then((res) => {
              if (res.data.success) {
                this.message = "Project closed successfully";
                this.showAlert('success');
                this.getProjects(); // Refresh projects list
              } else {
                this.message = res.data.message || "Failed to close project";
                this.showAlert('failed');
              }
            })
            .catch((e) => {
              this.message = e.message || "An error occurred while closing the project";
              this.showAlert('failed');
            });
      }
    },

    // Select project for editing
    selectProject(project) {
      this.currentProject = { ...project }; // Clone to avoid direct mutation
    },

    // Format date for display
    formatDate(dateString) {
      if (!dateString) return 'N/A';
      const date = new Date(dateString);
      return date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      });
    },

    // Format number with commas
    formatNumber(number) {
      return number ? number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0';
    },

    // Get appropriate badge class for status
    getStatusBadgeClass(status) {
      if (!status) return '';

      const statusLower = status.toLowerCase();
      const classes = {
        'ongoing': 'badge rounded-pill bg-success text-uppercase fw-bold',
        'open': 'badge rounded-pill bg-info text-uppercase fw-bold',
        'pending': 'badge rounded-pill bg-warning text-uppercase fw-bold',
        'active': 'badge rounded-pill bg-success text-uppercase fw-bold',
        'delayed': 'badge rounded-pill bg-warning text-uppercase fw-bold',
        'closed': 'badge rounded-pill bg-dark text-uppercase fw-bold',
        'completed': 'badge rounded-pill bg-primary text-uppercase fw-bold'
      };

      return classes[statusLower] || 'badge rounded-pill bg-secondary text-uppercase fw-bold';
    },

    // Activate a project (change status from Pending to Active)
    activateProject(projectId) {
      if (confirm("Are you sure you want to activate this project?")) {
        this.showAlert('info');
        const data = new FormData();
        data.append("function", "updateProjectStatus");
        data.append("projectID", projectId);
        data.append("status", "Active");

        execute(data, authUrl)
            .then((res) => {
              if (res.data.success) {
                this.message = "Project activated successfully";
                this.showAlert('success');
                this.getProjects(); // Refresh projects list
              } else {
                this.message = res.data.message || "Failed to activate project";
                this.showAlert('failed');
              }
            })
            .catch((e) => {
              this.message = e.message || "An error occurred while activating the project";
              this.showAlert('failed');
            });
      }
    },

    // Search personnel by keyword
    searchEmployees() {
      // Debounce function to prevent too many API calls
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }

      this.searchTimeout = setTimeout(() => {
        this.getEmployees(this.personnelSearchKeyword);
      }, 300); // 300ms delay
    },

    // Open project members modal
    openProjectMembersModal(project) {
      this.selectedProject = project;
      this.newProjectMember.projectID = project.id;
      this.newProjectMember.employeeID = '';
      this.newProjectMember.role = '';

      this.getProjectMembers(project.id);

      // Open the modal
      const modal = new bootstrap.Modal(document.getElementById('addProjectMembersModal'));
      modal.show();
    },

    // Get project members
    getProjectMembers(projectId) {
      const data = new FormData();
      data.append("function", "getProjectMembers");
      data.append("projectID", projectId);

      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              this.projectMembers = res.data.data.projectMembers || [];
            } else {
              console.error("Failed to load project members:", res.data.message);
              this.projectMembers = [];
            }
          })
          .catch((e) => {
            console.error("Error loading project members:", e);
            this.projectMembers = [];
          });
    },

    // Add project member
    addProjectMember() {
      if (!this.newProjectMember.employeeID || !this.newProjectMember.role) {
        this.message = "Please select a member and specify their role";
        this.showAlert('failed');
        return;
      }

      this.showAlert('info');
      const data = new FormData();
      data.append("function", "addProjectMember");
      data.append("projectID", this.newProjectMember.projectID);
      data.append("employeeID", this.newProjectMember.employeeID);
      data.append("role", this.newProjectMember.role);

      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              this.message = "Project member added successfully";
              this.showAlert('success');
              this.getProjectMembers(this.newProjectMember.projectID);

              // Reset form
              this.newProjectMember.employeeID = '';
              this.newProjectMember.role = '';
            } else {
              this.message = res.data.message || "Failed to add project member";
              this.showAlert('failed');
            }
          })
          .catch((e) => {
            this.message = e.message || "An error occurred while adding the project member";
            this.showAlert('failed');
          });
    },

    // Remove project member
    removeProjectMember(memberId) {
      if (confirm("Are you sure you want to remove this member from the project?")) {
        this.showAlert('info');
        const data = new FormData();
        data.append("function", "removeProjectMember");
        data.append("memberID", memberId);

        execute(data, authUrl)
            .then((res) => {
              if (res.data.success) {
                this.message = "Project member removed successfully";
                this.showAlert('success');
                this.getProjectMembers(this.selectedProject.id);
              } else {
                this.message = res.data.message || "Failed to remove project member";
                this.showAlert('failed');
              }
            })
            .catch((e) => {
              this.message = e.message || "An error occurred while removing the project member";
              this.showAlert('failed');
            });
      }
    },

    // Reset the new project form with proper initialization
    resetNewProjectForm() {
      const today = new Date().toISOString().split('T')[0];

      this.newProject = {
        projectName: "",
        description: "",
        status: "pending",
        priority: "medium",
        budget: 0,
        actualCost: 0,
        managerID: "",
        departmentID: "",
        clientName: "",
        createdAt: today, // Set today as default start date
        endDate: "",
        location: "",
        currency: "KES"
      };
    },

    // Filter projects by department
    filterProjects() {
      this.loading = true;
      const data = new FormData();
      data.append("function", "getProjects");

      if (this.selectedDepartment) {
        data.append("departmentID", this.selectedDepartment);
      }

      execute(data, authUrl)
          .then((res) => {
            this.loading = false;
            if (res.data.success) {
              this.projects = res.data.data.projects;
            } else {
              this.message = res.data.message || "Failed to filter projects";
              this.showAlert('failed');
            }
          })
          .catch((e) => {
            this.loading = false;
            this.message = e.message || "An error occurred while filtering projects";
            this.showAlert('failed');
          });
    },

    // Show alert message
    showAlert(type) {
      this.alert.success = type === 'success';
      this.alert.info = type === 'info';
      this.alert.failed = type === 'failed';

      // Auto-hide success and failed alerts after 3 seconds
      if (type === 'success' || type === 'failed') {
        setTimeout(() => {
          this.alert.success = false;
          this.alert.failed = false;
        }, 3000);
      }
    }
  }
};
</script>

<style scoped>
/* Custom styles */
.projects-table th, .projects-table td {
  vertical-align: middle;
}

.search-box .search-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
}

.modal-header.bg-primary {
  color: white;
}

/* Make sure all required fields are properly highlighted */
.form-control:required, .form-select:required {
  border-left: 3px solid #20c997;
}

.form-control:required:invalid:focus, .form-select:required:invalid:focus {
  border-left: 3px solid #dc3545;
}
</style>
